import { REDUCER_NAME } from './const'
import { REDUCER_NAME as PARENT_REDUCER_NAME } from '../const'

const NS = PARENT_REDUCER_NAME + '/' + REDUCER_NAME + '/'

export const CHANGE_REASSIGNMENT = NS + 'CHANGE_REASSIGNMENT'

export const REASSIGN_TREATING_PHYSICIAN_REQUEST = NS + 'REASSIGN_TREATING_PHYSICIAN_REQUEST'
export const REASSIGN_TREATING_PHYSICIAN_SUCCESS = NS + 'REASSIGN_TREATING_PHYSICIAN_SUCCESS'
export const REASSIGN_TREATING_PHYSICIAN_ERROR = NS + 'REASSIGN_TREATING_PHYSICIAN_ERROR'

export const REASSIGN_TO_PARTNER_PHYSICIAN_REQUEST = NS + 'REASSIGN_TO_PARTNER_PHYSICIAN_REQUEST'
export const REASSIGN_TO_PARTNER_PHYSICIAN_SUCCESS = NS + 'REASSIGN_TO_PARTNER_PHYSICIAN_SUCCESS'
export const REASSIGN_TO_PARTNER_PHYSICIAN_ERROR = NS + 'REASSIGN_TO_PARTNER_PHYSICIAN_ERROR'




// WEBPACK FOOTER //
// ./src/modules/treatment/state/reassign/type.js